import useGetNewspapers from './useGetNewspapers'

export default useGetNewspapers
